
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 4.5a.75.75 0 01.75-.75h3.5a.75.75 0 01.75.75v15a.75.75 0 01-.75.75h-3.5a.75.75 0 01-.75-.75v-15zm1.5.75v13.5h2V5.25H4zm5.5-.75a.75.75 0 01.75-.75h3.5a.75.75 0 01.75.75v15a.75.75 0 01-.75.75h-3.5a.75.75 0 01-.75-.75v-15zm1.5.75v13.5h2V5.25h-2zm6.25-1.5a.75.75 0 00-.75.75v15c0 .414.336.75.75.75h3.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75h-3.5zm.75 15V5.25h2v13.5h-2z"}})])
          )
        }
      }
    